// frontend/src/screens/formateur/FormateurPlaylist.js - VERSION CORRIGÉE
import React, { useState, useEffect } from 'react';
import { Col, Card, Button, Modal, Form, Spinner, Row, Alert, Container, Badge } from 'react-bootstrap';
import { useNavigate, Link } from 'react-router-dom';
import { useSelector } from 'react-redux';
import { toast } from 'react-toastify';
import { 
  useGetFormateurPlaylistsQuery,
  useCreatePlaylistMutation,
  useUpdatePlaylistMutation
} from '../../slices/playlistsApiSlice';
import { useGetProductsQuery } from '../../slices/productsApiSlice';
import { BASE_URL } from '../../constants';

const FormateurPlaylist = () => {
  const [currentPage, setCurrentPage] = useState(1);
  const playlistsPerPage = 6;
  const [showModal, setShowModal] = useState(false);
  const [showEditModal, setShowEditModal] = useState(false);
  const [editingPlaylist, setEditingPlaylist] = useState(null);
  const [newPlaylistName, setNewPlaylistName] = useState('');
  const [newPlaylistDescription, setNewPlaylistDescription] = useState('');
  const [selectedProduct, setSelectedProduct] = useState('');
  const [newPlaylistImage, setNewPlaylistImage] = useState(null);
  const [error, setError] = useState('');
  const [imageErrors, setImageErrors] = useState({});
  
  const navigate = useNavigate();
  const { userInfo } = useSelector((state) => state.auth);

  // ✅ RTK Query pour les playlists du formateur
  const { 
    data: playlistsData, 
    isLoading: playlistsLoading, 
    error: playlistsError,
    refetch: refetchPlaylists
  } = useGetFormateurPlaylistsQuery();

  // ✅ RTK Query pour les produits du formateur
  const { 
    data: productsData,
    isLoading: productsLoading,
    refetch: refetchProducts 
  } = useGetProductsQuery({
    pageNumber: 1,
    sortBy: 'position_asc'
  });

  // ✅ Mutations RTK Query (sans suppression)
  const [createPlaylist, { isLoading: creatingPlaylist }] = useCreatePlaylistMutation();
  const [updatePlaylist, { isLoading: updatingPlaylist }] = useUpdatePlaylistMutation();

  // ✅ CORRECTION: Filtrer les produits du formateur (type 1) créés par lui
  const myProducts = productsData?.products?.filter(
    product => product.type === 1 && product.user === userInfo?._id
  ) || [];

  const playlists = playlistsData || [];

  // ✅ CORRECTION AMÉLIORÉE: Fonction pour obtenir l'URL de l'image
  const getPlaylistImageUrl = (playlist) => {
    if (!playlist.image) {
      return '/images/placeholder-playlist.jpg';
    }
    
    // Si c'est déjà une URL complète
    if (playlist.image.startsWith('http') || playlist.image.startsWith('https')) {
      return playlist.image;
    }
    
    // Si c'est un chemin relatif, construire l'URL complète
    const baseUrl = BASE_URL || '';
    
    // Nettoyer le chemin (enlever les doubles slash)
    const cleanPath = playlist.image.startsWith('/') ? playlist.image : `/${playlist.image}`;
    
    return `${baseUrl}${cleanPath}`;
  };

  // ✅ Gestion des erreurs d'image
  const handleImageError = (playlistId) => {
    setImageErrors(prev => ({
      ...prev,
      [playlistId]: true
    }));
  };

  // ✅ Fonction pour créer une playlist
  const handlePlaylistAdd = async () => {
    if (!selectedProduct) {
      setError('Veuillez sélectionner une de vos formations');
      return;
    }

    if (!newPlaylistName.trim()) {
      setError('Veuillez saisir un nom pour la playlist');
      return;
    }

    try {
      const formData = new FormData();
      formData.append('name', newPlaylistName.trim());
      formData.append('description', newPlaylistDescription.trim());
      formData.append('product', selectedProduct);
      
      // Ajouter l'image si elle existe
      if (newPlaylistImage) {
        formData.append('image', newPlaylistImage);
      }

      await createPlaylist(formData).unwrap();
      
      toast.success('Playlist créée avec succès');
      handleCloseModal();
      refetchPlaylists();
    } catch (err) {
      console.error('❌ Error creating playlist:', err);
      const errorMessage = err?.data?.error || err?.data?.message || 'Échec de la création de la playlist';
      setError(errorMessage);
      toast.error(errorMessage);
    }
  };

  // ✅ FONCTION CORRIGÉE : Modifier une playlist
  const handlePlaylistEdit = async () => {
    if (!editingPlaylist || !selectedProduct) {
      setError('Veuillez remplir tous les champs obligatoires');
      return;
    }

    try {
      const formData = new FormData();
      formData.append('name', newPlaylistName.trim());
      formData.append('description', newPlaylistDescription.trim());
      formData.append('product', selectedProduct);
      
      // Ajouter l'image si elle existe
      if (newPlaylistImage) {
        formData.append('image', newPlaylistImage);
      }

     // console.log('🔄 Tentative de modification de playlist:', editingPlaylist._id);
      
      // ✅ CORRECTION : Utiliser directement l'ID sans wrapper supplémentaire
await updatePlaylist({
  playlistId: editingPlaylist._id,
  formData: formData
}).unwrap(); // ✅ Variable supprimée
      
      //console.log('✅ Playlist modifiée avec succès:', result);
      toast.success('Playlist modifiée avec succès');
      handleCloseEditModal();
      refetchPlaylists();
    } catch (err) {
      console.error('❌ Error updating playlist:', err);
      const errorMessage = err?.data?.error || err?.data?.message || 'Échec de la modification - Vérifiez vos permissions';
      setError(errorMessage);
      toast.error(errorMessage);
    }
  };

  // ✅ Fonction pour ouvrir le modal de création
  const handleShowModal = () => {
    if (myProducts.length === 0) {
      toast.error('Vous devez d\'abord créer une formation en ligne');
      return;
    }
    setShowModal(true);
  };

  // ✅ Fonction pour fermer le modal de création
  const handleCloseModal = () => {
    setShowModal(false);
    setNewPlaylistName('');
    setNewPlaylistDescription('');
    setSelectedProduct('');
    setNewPlaylistImage(null);
    setError('');
  };

  // ✅ Fonction pour ouvrir le modal d'édition
  const handleShowEditModal = (playlist) => {
    setEditingPlaylist(playlist);
    setNewPlaylistName(playlist.name);
    setNewPlaylistDescription(playlist.description || '');
    setSelectedProduct(playlist.product?._id || '');
    setNewPlaylistImage(null);
    setError('');
    setShowEditModal(true);
  };

  // ✅ Fonction pour fermer le modal d'édition
  const handleCloseEditModal = () => {
    setShowEditModal(false);
    setEditingPlaylist(null);
    setNewPlaylistName('');
    setNewPlaylistDescription('');
    setSelectedProduct('');
    setNewPlaylistImage(null);
    setError('');
  };

  // ✅ Pagination
  const indexOfLastPlaylist = currentPage * playlistsPerPage;
  const indexOfFirstPlaylist = indexOfLastPlaylist - playlistsPerPage;
  const currentPlaylists = playlists.slice(indexOfFirstPlaylist, indexOfLastPlaylist);
  const totalPages = Math.ceil(playlists.length / playlistsPerPage);

  const handlePageChange = (pageNumber) => {
    setCurrentPage(pageNumber);
  };

  // ✅ Redirection si non formateur
  useEffect(() => {
    if (userInfo && !userInfo.isFormateur && !userInfo.isAdmin) {
      navigate('/login');
    }
  }, [userInfo, navigate]);

  // ✅ Recharger les produits au chargement du composant
  useEffect(() => {
    refetchProducts();
  }, [refetchProducts]);

  const isLoading = playlistsLoading || creatingPlaylist || updatingPlaylist || productsLoading;

  return (
    <Container>
      <div className="d-flex justify-content-between align-items-center mb-4">
        <div>
          <h1 className="mb-1">🎓 Gestion de Mes Playlists</h1>
          <p className="text-muted">Créez et gérez les playlists pour vos formations</p>
        </div>
        <Button variant="outline-secondary" onClick={() => refetchPlaylists()}>
          <i className="fas fa-sync-alt me-2"></i>
          Actualiser
        </Button>
      </div>

      {/* Alert si pas de formations */}
      {myProducts.length === 0 && (
        <Alert variant="warning" className="mb-4">
          <div className="d-flex align-items-center">
            <i className="fas fa-exclamation-triangle fa-2x me-3 text-warning"></i>
            <div>
              <h5 className="mb-2">Créez d'abord vos formations en ligne</h5>
              <p className="mb-2">
                Vous devez créer des produits de type "Formation en ligne" (type=1) avant de pouvoir créer des playlists.
              </p>
              <div className="d-flex gap-2">
                <Link to="/formateur/productlist">
                  <Button variant="primary" size="sm">
                    <i className="fas fa-plus me-2"></i>
                    Créer une formation
                  </Button>
                </Link>
                <Button variant="outline-secondary" size="sm" onClick={refetchProducts}>
                  <i className="fas fa-sync-alt me-2"></i>
                  Actualiser
                </Button>
              </div>
            </div>
          </div>
        </Alert>
      )}

      {myProducts.length > 0 && (
        <>
          <div className="d-flex justify-content-between align-items-center mb-4">
            <div>
              <h2 className="mb-1">Mes Playlists ({playlists.length})</h2>
              <p className="text-muted mb-0">
                {playlists.length === 0 
                  ? 'Commencez par créer votre première playlist' 
                  : 'Gérez le contenu de vos formations'
                }
              </p>
            </div>
            <Button 
              variant='success' 
              onClick={handleShowModal} 
              disabled={isLoading}
              className="d-flex align-items-center"
            >
              {isLoading ? (
                <Spinner size="sm" className="me-2" />
              ) : (
                <i className="fas fa-plus me-2"></i>
              )}
              Créer une Playlist
            </Button>
          </div>
          
          {/* Messages d'erreur */}
          {error && (
            <Alert variant="danger" dismissible onClose={() => setError('')}>
              <i className="fas fa-exclamation-circle me-2"></i>
              {error}
            </Alert>
          )}
          
          {playlistsError && (
            <Alert variant="danger">
              <i className="fas fa-exclamation-triangle me-2"></i>
              Erreur lors du chargement des playlists
            </Alert>
          )}
          
          {/* Liste des playlists */}
          {playlists.length === 0 ? (
            <Alert variant="info" className="text-center py-5">
              <i className="fas fa-film fa-3x mb-3 text-muted"></i>
              <h4>Vous n'avez pas encore de playlists</h4>
              <p className="mb-3">
                Créez votre première playlist pour organiser le contenu de vos formations.
              </p>
              <Button variant="primary" onClick={handleShowModal}>
                <i className="fas fa-plus me-2"></i>
                Créer ma première playlist
              </Button>
            </Alert>
          ) : (
            <>
              <Row>
                {currentPlaylists.map((playlist) => (
                  <Col key={playlist._id} md={6} lg={4} className="mb-4">
                    <Card className="h-100 shadow-sm hover-shadow">
                      <div className="position-relative">
                        <Card.Img
                          variant='top'
                          src={imageErrors[playlist._id] ? '/images/placeholder-playlist.jpg' : getPlaylistImageUrl(playlist)}
                          alt={playlist.name}
                          style={{ 
                            width: '100%', 
                            height: '200px', 
                            objectFit: 'cover',
                            cursor: 'pointer'
                          }}
                          onError={() => handleImageError(playlist._id)}
                          onClick={() => handleShowEditModal(playlist)}
                        />
                        <div className="position-absolute top-0 end-0 m-2">
                          <Badge bg="primary">
                            {playlist.videos?.length || 0} fichier(s)
                          </Badge>
                        </div>
                      </div>
                      
                      <Card.Body className="d-flex flex-column">
                        <Card.Title 
                          className="h5 mb-2 text-truncate"
                          title={playlist.name}
                        >
                          {playlist.name}
                        </Card.Title>
                        
                        <Card.Text 
                          className="flex-grow-1 text-muted small"
                          style={{ 
                            display: '-webkit-box',
                            WebkitLineClamp: 3,
                            WebkitBoxOrient: 'vertical',
                            overflow: 'hidden'
                          }}
                        >
                          {playlist.description || 'Aucune description'}
                        </Card.Text>
                        
                        {playlist.product && (
                          <Card.Text className="text-muted small mb-2">
                            <strong>Formation :</strong> {playlist.product.name}
                          </Card.Text>
                        )}

                        <div className="mt-auto">
                          <small className="text-muted d-block mb-2">
                            <i className="fas fa-calendar me-1"></i>
                            Créée le {new Date(playlist.createdAt).toLocaleDateString('fr-FR')}
                          </small>
                          
                          {/* ✅ SECTION CORRIGÉE - SANS BOUTON SUPPRESSION */}
                          <div className="d-flex gap-2 flex-wrap">
                            <Button
                              variant='outline-secondary'
                              size="sm"
                              onClick={() => handleShowEditModal(playlist)}
                              disabled={isLoading}
                              className="flex-fill"
                            >
                              <i className="fas fa-edit me-1"></i>
                              Modifier
                            </Button>
                            <Link 
                              to={`/formateur/playlists/${playlist._id}/videos`}
                              className="flex-fill"
                            >
                              <Button variant='primary' size="sm" className="w-100">
                                <i className="fas fa-play-circle me-1"></i>
                                Contenu
                              </Button>
                            </Link>
                          </div>
                        </div>
                      </Card.Body>
                    </Card>
                  </Col>
                ))}
              </Row>

              {/* Pagination */}
              {totalPages > 1 && (
                <div className='pagination mt-4 d-flex justify-content-center align-items-center'>
                  <Button
                    variant='outline-primary'
                    onClick={() => handlePageChange(currentPage - 1)}
                    disabled={currentPage === 1}
                    className="me-2"
                  >
                    <i className="fas fa-chevron-left me-1"></i>
                    Précédent
                  </Button>
                  
                  <div className="mx-3">
                    {[...Array(totalPages).keys()].map((page) => (
                      <Button
                        key={page + 1}
                        variant={currentPage === page + 1 ? 'primary' : 'outline-primary'}
                        onClick={() => handlePageChange(page + 1)}
                        className="me-1"
                        size="sm"
                      >
                        {page + 1}
                      </Button>
                    ))}
                  </div>
                  
                  <Button
                    variant='outline-primary'
                    onClick={() => handlePageChange(currentPage + 1)}
                    disabled={currentPage === totalPages}
                    className="ms-2"
                  >
                    Suivant
                    <i className="fas fa-chevron-right ms-1"></i>
                  </Button>
                </div>
              )}
            </>
          )}

          {/* Modal de création de playlist */}
          <Modal show={showModal} onHide={handleCloseModal} size="lg">
            <Modal.Header closeButton>
              <Modal.Title>
                <i className="fas fa-plus-circle me-2 text-success"></i>
                Créer une Nouvelle Playlist
              </Modal.Title>
            </Modal.Header>
            <Modal.Body>
              <Form>
                <Form.Group controlId='playlistName' className="mb-3">
                  <Form.Label>
                    Nom de la Playlist *
                    <span className="text-danger ms-1">*</span>
                  </Form.Label>
                  <Form.Control
                    type='text'
                    value={newPlaylistName}
                    onChange={(e) => setNewPlaylistName(e.target.value)}
                    placeholder="Ex: Introduction à React, Bases de JavaScript..."
                    required
                    maxLength={100}
                  />
                  <Form.Text className="text-muted">
                    {newPlaylistName.length}/100 caractères
                  </Form.Text>
                </Form.Group>
                
                <Form.Group controlId='playlistDescription' className="mb-3">
                  <Form.Label>Description</Form.Label>
                  <Form.Control
                    as="textarea"
                    rows={3}
                    value={newPlaylistDescription}
                    onChange={(e) => setNewPlaylistDescription(e.target.value)}
                    placeholder="Décrivez le contenu de cette playlist..."
                    maxLength={500}
                  />
                  <Form.Text className="text-muted">
                    {newPlaylistDescription.length}/500 caractères
                  </Form.Text>
                </Form.Group>
                
                <Form.Group controlId='playlistProduct' className="mb-3">
                  <Form.Label>
                    Formation associée *
                    <span className="text-danger ms-1">*</span>
                  </Form.Label>
                  <Form.Select
                    value={selectedProduct}
                    onChange={(e) => setSelectedProduct(e.target.value)}
                    required
                  >
                    <option value="">Sélectionnez votre formation</option>
                    {myProducts.map((product) => (
                      <option key={product._id} value={product._id}>
                        {product.name} - {product.price} TND
                      </option>
                    ))}
                  </Form.Select>
                  <Form.Text className="text-muted">
                    Seules vos formations en ligne (type=1) sont affichées
                  </Form.Text>
                </Form.Group>

                {/* Champ pour uploader une image */}
                <Form.Group controlId='playlistImage' className="mb-3">
                  <Form.Label>Image de la Playlist</Form.Label>
                  <Form.Control
                    type='file'
                    accept="image/*"
                    onChange={(e) => setNewPlaylistImage(e.target.files[0])}
                  />
                  <Form.Text className="text-muted">
                    Format recommandé : JPG, PNG ou WebP (max 2MB). 
                    Cette image sera utilisée comme miniature pour votre playlist.
                  </Form.Text>
                </Form.Group>
              </Form>
            </Modal.Body>
            <Modal.Footer>
              <Button variant='secondary' onClick={handleCloseModal} disabled={creatingPlaylist}>
                <i className="fas fa-times me-2"></i>
                Annuler
              </Button>
              <Button
                variant='primary'
                onClick={handlePlaylistAdd}
                disabled={creatingPlaylist || !newPlaylistName.trim() || !selectedProduct}
              >
                {creatingPlaylist ? (
                  <>
                    <Spinner size="sm" className="me-2" />
                    Création...
                  </>
                ) : (
                  <>
                    <i className="fas fa-check me-2"></i>
                    Créer la Playlist
                  </>
                )}
              </Button>
            </Modal.Footer>
          </Modal>

          {/* Modal d'édition de playlist */}
          <Modal show={showEditModal} onHide={handleCloseEditModal} size="lg">
            <Modal.Header closeButton>
              <Modal.Title>
                <i className="fas fa-edit me-2 text-primary"></i>
                Modifier la Playlist
              </Modal.Title>
            </Modal.Header>
            <Modal.Body>
              <Form>
                <Form.Group controlId='editPlaylistName' className="mb-3">
                  <Form.Label>
                    Nom de la Playlist *
                    <span className="text-danger ms-1">*</span>
                  </Form.Label>
                  <Form.Control
                    type='text'
                    value={newPlaylistName}
                    onChange={(e) => setNewPlaylistName(e.target.value)}
                    required
                    maxLength={100}
                  />
                  <Form.Text className="text-muted">
                    {newPlaylistName.length}/100 caractères
                  </Form.Text>
                </Form.Group>
                
                <Form.Group controlId='editPlaylistDescription' className="mb-3">
                  <Form.Label>Description</Form.Label>
                  <Form.Control
                    as="textarea"
                    rows={3}
                    value={newPlaylistDescription}
                    onChange={(e) => setNewPlaylistDescription(e.target.value)}
                    maxLength={500}
                  />
                  <Form.Text className="text-muted">
                    {newPlaylistDescription.length}/500 caractères
                  </Form.Text>
                </Form.Group>
                
                <Form.Group controlId='editPlaylistProduct' className="mb-3">
                  <Form.Label>
                    Formation associée *
                    <span className="text-danger ms-1">*</span>
                  </Form.Label>
                  <Form.Select
                    value={selectedProduct}
                    onChange={(e) => setSelectedProduct(e.target.value)}
                    required
                  >
                    <option value="">Sélectionnez votre formation</option>
                    {myProducts.map((product) => (
                      <option key={product._id} value={product._id}>
                        {product.name} - {product.price} TND
                      </option>
                    ))}
                  </Form.Select>
                  <Form.Text className="text-muted">
                    Seules vos formations en ligne sont affichées
                  </Form.Text>
                </Form.Group>

                {/* Champ pour uploader une image */}
                <Form.Group controlId='editPlaylistImage' className="mb-3">
                  <Form.Label>Image de la Playlist</Form.Label>
                  <Form.Control
                    type='file'
                    accept="image/*"
                    onChange={(e) => setNewPlaylistImage(e.target.files[0])}
                  />
                  <Form.Text className="text-muted">
                    Laissez vide pour conserver l'image actuelle
                  </Form.Text>
                  {editingPlaylist?.image && (
                    <div className="mt-2 p-2 bg-light rounded">
                      <small className="text-muted d-block mb-1">Image actuelle :</small>
                      <img 
                        src={getPlaylistImageUrl(editingPlaylist)} 
                        alt="Current playlist" 
                        style={{ 
                          width: '80px', 
                          height: '60px', 
                          objectFit: 'cover',
                          borderRadius: '4px'
                        }}
                      />
                    </div>
                  )}
                </Form.Group>
              </Form>
            </Modal.Body>
            <Modal.Footer>
              <Button variant='secondary' onClick={handleCloseEditModal} disabled={updatingPlaylist}>
                <i className="fas fa-times me-2"></i>
                Annuler
              </Button>
              <Button
                variant='primary'
                onClick={handlePlaylistEdit}
                disabled={updatingPlaylist || !newPlaylistName.trim() || !selectedProduct}
              >
                {updatingPlaylist ? (
                  <>
                    <Spinner size="sm" className="me-2" />
                    Modification...
                  </>
                ) : (
                  <>
                    <i className="fas fa-save me-2"></i>
                    Enregistrer les modifications
                  </>
                )}
              </Button>
            </Modal.Footer>
          </Modal>
        </>
      )}

      {/* Statistiques */}
      {playlists.length > 0 && (
        <Alert variant="light" className="mt-4">
          <Row>
            <Col md={3} className="text-center">
              <h4 className="text-primary mb-1">{playlists.length}</h4>
              <small className="text-muted">Playlists créées</small>
            </Col>
            <Col md={3} className="text-center">
              <h4 className="text-success mb-1">
                {playlists.reduce((total, playlist) => total + (playlist.videos?.length || 0), 0)}
              </h4>
              <small className="text-muted">Fichiers totaux</small>
            </Col>
            <Col md={3} className="text-center">
              <h4 className="text-info mb-1">{myProducts.length}</h4>
              <small className="text-muted">Formations actives</small>
            </Col>
            <Col md={3} className="text-center">
              <h4 className="text-warning mb-1">
                {playlists.filter(p => p.videos?.length > 0).length}
              </h4>
              <small className="text-muted">Playlists avec contenu</small>
            </Col>
          </Row>
        </Alert>
      )}
    </Container>
  );
};

export default FormateurPlaylist;